<template>
  <figure>
    <canvas :id="chartID" aria-label="Chart" role="img"></canvas>
  </figure>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "Chart",
  props: ["chartID", "type", "datasets", "labels"],
  data() {
    return {
      chartElement: {}
    };
  },
  mounted() {
    // Add gradients.
    const ctx = document.getElementById(this.chartID).getContext("2d");
    const grd = ctx.createLinearGradient(150.0, 0.0, 150.0, 400.0);
    
    grd.addColorStop(0.0, "rgba(155, 48, 28, 0.25)");
    grd.addColorStop(0.814, "rgba(155, 48, 28, 0.000)");

    // Loop through datasets and find any gradients.
    this.datasets.forEach((set, index) => {
      if (set.backgroundColor === "gradient") {
        this.datasets[index].backgroundColor = grd;
      }
    });

    // Create the chart.
    this.createChart();
  },
  methods: {
    createChart() {
      const element = document.getElementById(this.chartID);

      this.chartElement = new Chart(element, {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: this.datasets
        },
        options: {
          maintainAspectRatio: false,
          legend: {
            labels: {
              boxWidth: 12,
              fontColor: "#13191f",
              fontFamily: "Montserrat",
              padding: 35
            }
          }
        }
      });
    }
  }
};
</script>

<style>
figure {
  height: 450px;
}
</style>
